import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as ticketIt } from "./i18n/ticket.lang-it";
import ticketSettingsLinks from "./ticket.settings-list";
import { RouterModule } from "@angular/router";
import ticketRoutes from "./ticket.routes";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { OpenTicketComponent } from "./components/modal-open-ticket/open-ticket.component";
import { CategoriesTicketListComponent } from "./pages/categories-ticket-list/categories-ticket-list.component";
import { AllUsersTicketListComponent } from "./pages/all-users-ticket-list/all-users-ticket-list.component";
import { MyTicketListComponent } from "./pages/my-ticket-list/my-ticket-list.component";
import ticketMenu from "./ticket.menu";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ModalEditTicketComponent } from "./components/modal-edit-ticket/modal-edit-ticket.component";
import { LayoutModule } from "../../layout/layout.module";
import { AuthenticationService } from "../../auth/service";

@NgModule({
  declarations: [OpenTicketComponent, MyTicketListComponent, AllUsersTicketListComponent, CategoriesTicketListComponent, ModalEditTicketComponent],
  exports: [OpenTicketComponent],
  imports: [
    RouterModule.forChild(ticketRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    AngularEditorModule,
    LayoutModule
  ]
})
export class TicketModule {
  constructor(private _utils: UtilsService, private _auth: AuthenticationService) {
    if (this._auth.currentUserSubject.value?.type === "Dipendente") {
      this._utils.initModule("ticket", ticketIt, ticketMenu, ticketSettingsLinks);
    }
  }
}
